export default __webpack_public_path__ + "static/media/tree14.46dbc35e.png";